<div class="permits-import-wrapper">
    <div id="permits-import" class="permits-import">
        <div class="card-box">
            <h2>Permisos</h2>
            <div class="radio-list">
                <mat-radio-group [(ngModel)]="selectedRoleType" aria-label="Select an option">
                    <mat-radio-button name="roleType" *ngFor="let tipo of _viewService.tipoList" [value]="tipo.value">
                        {{ tipo.viewValue }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="button-row">
                <button mat-raised-button color="accent" (click)="addNewRoles()">Roles</button>
                <button mat-raised-button color="accent" [routerLink]="['/users/']">
                    Usuarios
                </button>
            </div>
        </div>
    </div>

    <div class="permits-import-content">
        <div class="left">
            <mat-tab-group (selectedTabChange)="tabChanged($event)">
                <mat-tab [label]="tab.viewValue" *ngFor="let tab of _viewService.managementTabList">
                    <app-permit-groups *ngIf="tabName == tab.viewValue" [grupo]="tab.value" [roleType]="selectedRoleType">
                    </app-permit-groups>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>